module.exports = __webpack_public_path__ + "img/benefit-06-logo-pc.5634dd49.png";